import { Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import { Box } from "@mui/system"

const StyledBox = styled(Box)(({ bgColor }) => ({
  marginLeft: "30px",
  marginRight: "30px",
  padding: "16px",
  borderRadius: "5px",
  backgroundColor: bgColor
}))

const WorkOrderCardReadMessage = ({ message, title, bgColor }) => {
  return (
    <Box>
      <Typography variant="h6" p={4} pb={2}>
        {title}
      </Typography>
      <StyledBox bgColor={bgColor}>
        <Typography p={2}>{message}</Typography>
      </StyledBox>
    </Box>
  )
}

export default WorkOrderCardReadMessage
